export default __webpack_public_path__ + "static/wave22-f246565cd489180e3eebe957a6c4b4d5.png";